import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SPANS = [
  "md:col-span-7 h-72 md:h-[430px]",
  "md:col-span-5 h-72 md:h-[430px]",
  "md:col-span-4 h-64",
  "md:col-span-4 h-64",
  "md:col-span-4 h-64",
  "md:col-span-6 h-64",
  "md:col-span-6 h-64",
];

const Gallery = ({ content, images }) => (
  <section id="gallery" className="relative py-24 sm:py-32 bg-paper" data-testid="gallery-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="font-script text-verm text-3xl sm:text-4xl" data-testid="gallery-script">
            Moments Worth Looking Up For
          </p>
          <h2 className="mt-3 font-display font-bold text-navy text-4xl sm:text-5xl" data-testid="gallery-heading">
            The Gallery
          </h2>
        </div>
        {content.instagram_url ? (
          <a
            href={content.instagram_url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="gallery-follow-link"
            className="inline-flex items-center gap-2 font-semibold text-navy border-b-2 border-marigold hover:text-verm hover:border-verm transition-colors duration-300 pb-1"
          >
            Follow Our Journey
            <ArrowUpRight className="w-4 h-4" />
          </a>
        ) : null}
      </Reveal>

      {images?.length ? (
        <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-5" data-testid="gallery-grid">
          {images.slice(0, 10).map((img, i) => (
            <motion.figure
              key={img.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className={`relative group overflow-hidden rounded-xl border-2 border-navy/15 ${SPANS[i % SPANS.length]}`}
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={img.url}
                alt={img.caption || "Wind Skaters kiting moment"}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-navy/85 to-transparent text-paper font-body font-semibold text-sm px-4 py-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                {img.caption || "Wind Skaters"}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      ) : (
        <div
          className="mt-12 border-2 border-dashed border-navy/25 rounded-2xl p-16 text-center text-navy/60 font-body"
          data-testid="gallery-empty"
        >
          The sky is empty for now — add photos from the admin panel.
        </div>
      )}
    </div>
  </section>
);

export default Gallery;
